export const PERSONAL_EMAIL_DOMAINS = [
  // Global majors
  'gmail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.co.in',
  'yahoo.co.jp',
  'ymail.com',
  'rocketmail.com',
  'outlook.com',
  'hotmail.com',
  'hotmail.co.uk',
  'live.com',
  'live.co.uk',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'aim.com',
  'mail.com',
  'email.com',
  'usa.com',

  // Privacy-focused
  'protonmail.com',
  'proton.me',
  'pm.me',
  'tutanota.com',
  'tuta.com',
  'tutamail.com',
  'fastmail.com',
  'hushmail.com',
  'mailfence.com',
  'posteo.de',
  'disroot.org',

  // Zoho
  'zoho.com',
  'zohomail.com',

  // Russian / CIS
  'mail.ru',
  'yandex.com',
  'yandex.ru',
  'rambler.ru',
  'bk.ru',
  'list.ru',
  'inbox.ru',

  // Chinese
  'qq.com',
  '163.com',
  '126.com',
  'sina.com',
  'sohu.com',
  'aliyun.com',

  // Korean
  'naver.com',
  'daum.net',
  'hanmail.net',
  'kakao.com',

  // Indian
  'rediffmail.com',

  // German
  'web.de',
  'gmx.com',
  'gmx.de',
  'gmx.net',
  'gmx.at',
  't-online.de',
  'freenet.de',

  // French
  'laposte.net',
  'orange.fr',
  'sfr.fr',
  'free.fr',

  // Italian
  'libero.it',
  'virgilio.it',
  'tiscali.it',

  // Polish
  'wp.pl',
  'o2.pl',
  'interia.pl',
  'onet.pl',

  // Czech
  'seznam.cz',

  // Ukrainian
  'ukr.net',
  'i.ua',

  // Australian
  'bigpond.com',
  'optusnet.com.au',

  // UK ISPs
  'btinternet.com',
  'sky.com',
  'virginmedia.com',
  'talktalk.net',

  // US ISPs
  'comcast.net',
  'verizon.net',
  'att.net',
  'sbcglobal.net',
  'cox.net',
  'charter.net',
  'earthlink.net',
  'bellsouth.net',
  'windstream.net',

  // Israel
  'walla.co.il',
  'walla.com',
  'netvision.net.il',
  'bezeqint.net',
  'zahav.net.il',
  '012.net.il',
  '013.net',
  'smile.net.il',
  'inter.net.il',
  'hot.net.il',
  'partner.net.il',
  'cellcom.co.il',

  // Latin America
  'bol.com.br',
  'uol.com.br',
  'terra.com.br',

  // Spain / Portugal
  'terra.es',
  'sapo.pt',

  // Nordic
  'telia.com',

  // Dutch
  'ziggo.nl',
  'kpnmail.nl',

  // Swiss
  'bluewin.ch',

  // Canadian
  'rogers.com',
  'shaw.ca',
  'bell.net',
  'sympatico.ca',
];

export const isWorkEmail = (email: string): boolean => {
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;
  return !PERSONAL_EMAIL_DOMAINS.includes(domain);
};